import axios from "axios";

export default {
  namespaced: true,
  state: {
    loadingCliente:false,
    landscape: false,
    maximo: new Date()
      .toLocaleString("sv", { timeZoneName: "short" })
      .substr(0, 10), // fecha
    minimo: "2019",
    localidad: "es-cl",
    dsAgenda: [],
    loadingAgenda: false,
    idCliente: -1,
    idComponentAgnd: 1,
    GrupoClienteAgenda: -1,
    DetalleClienteAgenda: [],
    dsAgendaVisitasCombo: [],
    dsAgendaVisitas: [],
    dsAgendaVisitasDocPen: [],
    dsAgendaVisitasDocPenAll: [],
    dsAgendaVisitasDocVenAll: [],
    dsAgendaVisitasDocVen: [],
    dsAgendaVisitasPendi: [],
    dsAgendaVisitasVenci: [],
    dsAgendaVisitasDocVentas: [],
    dsAgendaVisitasDocVentasAll: [],
    dataCobranza: [],
    ttOrdenServ: [],
    filterAgenda: {
      tipo: [],
      visitado: [],
      ciudad: [],
      statusagenda: [],
    },
  },
  mutations: {
    setLoadingCliente(state, data) {
      state.loadingCliente = data;
    },
    
    set_loadingAgenda(state, data) {
      state.loadingAgenda = data;
    },
    setDataCobranza(state, data) {
      state.dataCobranza = data;
    },
    clrDataCobranza(state) {
      state.dataCobranza = [];
    },
    set_ttOrdenServ(state, data) {
      state.ttOrdenServ = data;
    },
    clr_ttOrdenServ(state) {
      state.ttOrdenServ = [];
    },
    set_dsAgenda(state, data) {
      state.dsAgenda = data;
    },
    clr_dsAgenda(state) {
      state.dsAgenda = [];
    },
    set_idComponenteAgnd(state) {
      state.idComponentAgnd++;
    },
    set_dsAgendaVisitasCombo(state, data) {
      state.dsAgendaVisitasCombo = data;
    },
    set_dsAgendaVisitas(state, data) {
      state.dsAgendaVisitas = data;
    },
    set_dsAgendaVisitasDocPen(state, { datos }) {
      state.dsAgendaVisitasDocPen = datos;
      state.dsAgendaVisitasDocPenAll.push(datos);
    },
    set_dsAgendaVisitasDocVentas(state, data) {
      state.dsAgendaVisitasDocVentas = data;
    },
    set_dsAgendaVisitasDocVentasAll(state, data) {
      state.dsAgendaVisitasDocVentasAll.push(data);
    },
    set_dsAgendaVisitasDocVen(state, { datos }) {
      state.dsAgendaVisitasDocVen = datos;
      state.dsAgendaVisitasDocVenAll.push(datos);
    },
    set_DetalleClienteAgendaOp(state, data) {
      state.GrupoClienteAgenda = data;
    },
    clr_dsAgendaVisitasDocPen(state) {
      state.dsAgendaVisitasDocPen = [];
    },
    clr_dsAgendaVisitasDocVen(state) {
      state.dsAgendaVisitasDocVen = [];
    },
    clr_dsAgendaVisitasDocVentas(state) {
      state.dsAgendaVisitasDocVentas = [];
    },

    clr_dsAgendaVisitasDocVenAll(state) {
      state.dsAgendaVisitasDocVenAll = [];
    },
    clr_dsAgendaVisitasDocPenAll(state) {
      state.dsAgendaVisitasDocPenAll = [];
    },
    clr_dsAgendaVisitasDocVentasAll(state) {
      state.dsAgendaVisitasDocVentasAll = [];
    },
    clr_dsAgendaVisitasCombo(state) {
      state.dsAgendaVisitasCombo = [];
    },
    clr_dsAgendaVisitas(state) {
      state.dsAgendaVisitas = [];
    },
    clr_filterAgendaVisit(state) {
      state.filterAgenda.visitado = [];
    },
    clr_DetalleClienteAgendaOp(state) {
      state.GrupoClienteAgenda = null;
    },
    set_idCliente(state, data) {
      state.idCliente = data;
    },
    clr_idCliente(state) {
      state.idCliente = -1;
    },
    set_filterAgendaciudad(state, data) {
      state.filterAgenda.ciudad = data;
    },
    clr_filterAgendaciudad(state) {
      state.filterAgenda.ciudad = [];
    },
    set_filterAgendastatus(state, data) {
      state.filterAgenda.statusagenda = data;
    },
    clr_filterAgendastatus(state) {
      state.filterAgenda.statusagenda = [];
    },
    set_filterAgendatipo(state, data) {
      state.filterAgenda.tipo = data;
    },
    set_DetalleClienteAgenda(state, data) {
      state.DetalleClienteAgenda = data;
    },
    clr_DetalleClienteAgenda(state) {
      state.DetalleClienteAgenda = [];
    },
    clr_filterAgendatipo(state) {
      state.filterAgenda.tipo = [];
    },
    set_filterAgendaVisit(state, data) {
      state.filterAgenda.visitado = data;
    },
  },
  actions: {
    get_DetalleClienteAgendaOpc: async ({ rootState, commit }, id) => {
      try {
        let respuesta = await axios.get(
          `${rootState.dirPHP}${rootState.server_query}`,
          {
            params: {
              program: "ConsultaClienteJson",
              usuario: rootState.dataUser.Usuario,
              cliente: id.cliente,
              opc: 1,
            },
          }
        );
        let data = await respuesta.data;

        let ttResumen = await data.ttResumen;

        let GrupoCliente = await ttResumen[0].GrupoCliente;

        commit("set_DetalleClienteAgendaOp", GrupoCliente);
      } catch (error) {
        console.log(error);
        //commit("ERROR_AXIOS");
      }
    },
    get_dsAgenda: async ({ rootState, commit }, id) => {
      try {
        commit("set_loadingAgenda", true);
        let respuesta = await axios.get(
          `${rootState.dirPHP}${rootState.server_query}`,
          {
            params: {
              program: "ccvisitaJson",
              usuario: rootState.dataUser.Usuario,
              vendedor: id.vendedor,
              cliente: id.cliente,
              opc: 6,
              mes: id.mes,
              anio: id.anio,
            },
          }
        );
        let data = await respuesta.data;
        let dsAgenda = await data.dsAgenda;
        commit("set_dsAgenda", dsAgenda);
        commit("set_loadingAgenda", false);
      } catch (error) {
        console.log(error);
        //commit("ERROR_AXIOS");
      }
    },
    get_DetalleClienteAgenda: async ({ rootState, commit }, id) => {
      try {
        let respuesta = await axios.get(
          `${rootState.dirPHP}${rootState.server_query}`,
          {
            params: {
              program: "ConsultaClienteJson",
              usuario: rootState.dataUser.Usuario,
              vergrupo: id.vergrupo,
              cliente: id.cliente,
              opc: id.opc,
            },
          }
        );
        let data = await respuesta.data;

        commit("set_DetalleClienteAgenda", data);
      } catch (error) {
        console.log(error);
        //commit("ERROR_AXIOS");
      }
    },
    getCobranza: async ({ state, rootState, commit }, id) => {
      let fecha = state.maximo.split(["-"]);


      try {
        commit("clrDataCobranza");
        commit("setLoadingCliente", true);
        let respuesta = await axios.get(
          `${rootState.dirPHP}${rootState.server_query}`,
          {
            params: {
              program: "EstadisticasVentasJson",
              userweb: rootState.dataUser.Usuario,
              ejec: id.ejec,
              vend: id.vend,
              dia: 0,
              sem: 0,
              mes: fecha[1],
              ano: fecha[0],
              opc: 12,
            },
          }
        );
        let data = await respuesta.data;
        if (respuesta.status === 200) {

          const {
            dsVentas: {
              wfCobranzaMes,
          
            },
          } = data;
          if (wfCobranzaMes!==undefined) {
            const dataMap = wfCobranzaMes.map((item)=>({Cliente: item.Cliente, NombreCli: item.NombreCli, TotalMes: item.TotalMes}))
            commit("setDataCobranza", dataMap);
          } 
        } 
      } catch (e) {
        console.log(e)
      } finally {
         commit("setLoadingCliente", false);
      }
    },
    agendaVisitas: async ({ rootState, commit }, id) => {
      try {
        //commit("set_loadingAgenda", true);
        let respuesta = await axios.get(
          `${rootState.dirPHP}${rootState.server_query}`,
          {
            params: {
              program: "AgendaVisitasJson",
              usuario: rootState.dataUser.Usuario,
              vendedor: id.vendedor,
              opc: id.opc,
              cliente: id.cliente,
            },
          }
        );
        if (id.opc == 0) {
          let data = await respuesta.data;

          let ttvended = await data.ttvended;
          if (ttvended.length > 0) commit("set_dsAgendaVisitasCombo", ttvended);
        }
        if (id.opc == 1 && id.vendedor != 0) {
          let data = await respuesta.data;

          let dsAgendaVisitas = await data.dsAgendaVisitas;

          commit("set_dsAgendaVisitas", dsAgendaVisitas);
          commit("set_loadingAgenda", false);
        }
        if (id.opc == 3 && id.vendedor != 0) {
          let data = await respuesta.data;

          let dsAgendaVisitas = await data.dsAgendaVisitas;
          if (dsAgendaVisitas.ttDocumentos.length > 0) {
            commit("set_dsAgendaVisitasDocPen", { datos: dsAgendaVisitas });
          }
        }
        if (id.opc == 5 && id.vendedor != 0) {
          let data = await respuesta.data;

          let dsAgendaVisitas = await data.dsAgendaVisitas;

          commit("set_dsAgendaVisitasDocVentas", dsAgendaVisitas);
          let { ttVentasCat } = dsAgendaVisitas;
          if (ttVentasCat !== undefined)
            commit("set_dsAgendaVisitasDocVentasAll", dsAgendaVisitas);
        }
        if (id.opc == 6 && id.vendedor != 0) {
          let data = await respuesta.data;

          let dsAgendaVisitas = await data.dsAgendaVisitas;

          commit("set_dsAgendaVisitasDocVen", { datos: dsAgendaVisitas });
        }
        if (id.opc == 8 && id.vendedor != 0) {
          let data = await respuesta.data;

          let dsAgendaVisitas = await data.dsAgendaVisitas;
          let ttOrdenServ = await dsAgendaVisitas.ttOrdenServ;

          commit("set_ttOrdenServ", ttOrdenServ);
        }
        //set_ttOrdenServ
        commit("set_loadingAgenda", false);
        //set_dsAgendaVisitasPendi
      } catch (error) {
        console.log(error);
        // commit("ERROR_AXIOS");
      }
    },
  },
  getters: {
    filteragenda: (rootState) => {
      if (Object.entries(rootState.dsAgendaVisitas).length !== 0) {
        return rootState.dsAgendaVisitas.ttDetalle.filter(
          (e) =>
            (rootState.filterAgenda.visitado.length === 0
              ? e.Visitado === e.Visitado
              : rootState.filterAgenda.visitado === e.Visitado) &&
            (rootState.filterAgenda.tipo.length === 0
              ? e.TipoVisita === e.TipoVisita
              : rootState.filterAgenda.tipo === e.TipoVisita) &&
            (rootState.filterAgenda.ciudad.length === 0
              ? e.Ciudad === e.Ciudad
              : rootState.filterAgenda.ciudad === e.Ciudad) &&
            (rootState.filterAgenda.statusagenda.length === 0
              ? e.IndAgenda === e.IndAgenda
              : rootState.filterAgenda.statusagenda === e.IndAgenda)
        );
      }
    },
  },
};
